import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { cookies_string } from '../../../config.js';
import { Login } from '../../../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeSvg from '../../../svg/menu/Home.js';
import MissionsSvg from '../../../svg/menu/Missions.js';
import ResultsSvg from '../../../svg/menu/Results.js';
import UsersSvg from '../../../svg/menu/Users.js';
import FaqSvg from '../../../svg/menu/Faq.js';
import LogoutSvg from '../../../svg/menu/Logout.js';
import PersonalInfoSvg from '../../../svg/menu/PersonalInfo.js';

function Component(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [__, _, removeCookie] = useCookies([`${cookies_string}_cred`, `${cookies_string}_token`]);
    const [isShowMenu, setisShowMenu] = useState(false)
    const handleLogout = () => {
        props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`, '/')
        removeCookie(`${cookies_string}_cred`, '/')
    }
    const toggleMenu = () => { setisShowMenu(!isShowMenu) }
    const handleRoute = (route) => () => {
        navigate(`/platform/${route}`);
    }
    const isMobile = window.innerWidth < 1024
    const [isHideMenu, setisHideMenu] = useState(false)


    if (location.pathname.split('/')[3] !== undefined && location.pathname.split('/')[2] === 'missions') {
        return (<div />)
    }

    if (isHideMenu) {
        return (
            <div className='flex flex-col justify-between items-center p-[6px] bg-[#F2F2F2]' style={{ borderRight: '1px solid #D7D7D7' }}>
                <div className='flex flex-col items-stretch gap-[16px] flex-1' style={{ overflowY: "auto" }}>
                    <div className='text-[blue] cursor-pointer' style={{ writingMode: 'vertical-lr' }} onClick={() => { setisHideMenu(false) }}>{'顯示選單'}</div>
                </div>
            </div>
        )
    }
    return (
        <div className='flex flex-col justify-between items-center bg-[#F2F2F2]' style={{ borderRight: '1px solid #D7D7D7',padding:isMobile?'4px':'16px' }}>
            <div className='flex flex-col items-stretch flex-1' style={{ overflowY: "auto" ,gap:isMobile?'8px':'16px'}}>
                {isMobile && <div className='underline text-[blue] cursor-pointer' onClick={() => { setisHideMenu(true) }}>隱藏選單</div>}
                <div onClick={handleRoute('')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] gap-[8px]' style={{padding:isMobile?8:16, opacity: ['', '/', '/home'].includes(location.pathname.split('/')[2]) ? 1 : .5 }}>
                    <HomeSvg width={isMobile?39/3*2:39}/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{ color: ['', 'home'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#727272', fontSize:isMobile?'12px':'20px' }}>
                        首頁
                    </div>
                </div>
                <div onClick={handleRoute('missions')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] gap-[8px]' style={{ padding:isMobile?8:16,opacity: ['missions'].includes(location.pathname.split('/')[2]) ? 1 : .5 }}>
                    <MissionsSvg  width={isMobile?46/3*2:46}/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{ color: ['missions'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#727272' , fontSize:isMobile?'12px':'20px' }}>閲讀任務</div>
                </div>
                {/* <div onClick={handleRoute('achievements')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['achievements'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <UsersSvg/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{color:['achievements'].includes(location.pathname.split('/')[2])?"#43528A":'#727272', fontSize:isMobile?'12px':'20px' }}>我的成就</div>
                </div> */}
                <div onClick={handleRoute('records')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] gap-[8px]' style={{ padding:isMobile?8:16,opacity: ['records'].includes(location.pathname.split('/')[2]) ? 1 : .5 }}>
                    <ResultsSvg  width={isMobile?53/3*2:53}/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{ color: ['records'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#727272' , fontSize:isMobile?'12px':'20px' }}>學習記錄</div>
                </div>
                {/* <div onClick={handleRoute('info')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['info'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <PersonalInfoSvg/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{color:['info'].includes(location.pathname.split('/')[2])?"#43528A":'#727272', fontSize:isMobile?'12px':'20px' }}>個人資料</div>
                </div> */}
                <div onClick={handleRoute('faq')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] gap-[8px]' style={{ padding:isMobile?8:16,opacity: ['faq'].includes(location.pathname.split('/')[2]) ? 1 : .5 }}>
                    <FaqSvg width={isMobile?52/3*2:52}/>
                    <div className='font-[700] flex-1 text-center px-[12px]' style={{ color: ['faq'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#727272' , fontSize:isMobile?'12px':'20px' }}>常見問題</div>
                </div>
            </div>

            <div onClick={handleLogout} className='w-full cursor-pointer flex flex-row justify-center items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[20px] mt-[16px]'>
                <LogoutSvg />
                <div className='font-[700] text-center' style={{ color: 'black' , fontSize:isMobile?'12px':'20px' }}>登出</div>
            </div>
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)